exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-transparent {\n  opacity: 0; }\n\n.is-solid {\n  opacity: 1; }\n\n.btn-group {\n  margin-top: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/deposits-shifts-container/deposits-shifts-container.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/deposits-shifts-container/deposits-shifts-container.component.scss
// module chunks = main